import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({ providedIn: 'root' })
export class ReservedQrStateService {
  private static reservedIdSubject = new BehaviorSubject<string | null>(null);
  public static reservedId$ = ReservedQrStateService.reservedIdSubject.asObservable();

  static setReservedId(id: string | null): void {
    ReservedQrStateService.reservedIdSubject.next(id);
  }

  static getReservedId(): string | null {
    return ReservedQrStateService.reservedIdSubject.getValue();
  }

  static clear(): void {
    ReservedQrStateService.reservedIdSubject.next(null);
  }
}
